import {Box, Button, CircularProgress, IconButton, Stack} from "@mui/material";
import {useEffect, useState} from "react";
import {FiEdit2, FiTrash2} from "react-icons/fi";
import {useLocation, useNavigate} from "react-router-dom";
import ScopeForm from "../components/Scopes/ScopeForm";
import ScopeInfo from "../components/Scopes/ScopeInfo";
import Window from "../components/Window/Window";
import useApiRequest from "../hooks/useApiRequest";
import ConfirmDialog from "../components/ui/ConfirmDialog";
import useConfirmDialog from "../hooks/useConfirmDialog";

const ScopeDetail = () => {
  const {state} = useLocation();
  const navigate = useNavigate();
  const id = state?.id;

  const isNewScope = !id;

  const {data, loading, read, remove} = useApiRequest({baseUrl: "/scopes", resource: "scopes"});

  const [isEditing, setIsEditing] = useState(isNewScope);

  const {confirmOpen, itemName, openDialog, handleConfirm, handleCancel} = useConfirmDialog(async () => {
    try {
      await remove(id);
      navigate("/scopes");
    } catch (error) {
      console.error("Error al eliminar el scope:", error);
    }
  });

  useEffect(() => {
    if (!isNewScope) {
      (async () => {
        try {
          await read(id);
        } catch (error) {
          console.error("Error al cargar los detalles del scope:", error);
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };

  const handleOpenDeleteDialog = () => {
    openDialog(id, data?.name || "");
  };

  return (
    <Window title={isNewScope ? "Nuevo Scope" : "Detalles del Scope"}>
      {loading && !isNewScope ? (
        <CircularProgress />
      ) : (
        <Stack direction="row" spacing={2} justifyContent={"space-between"}>
          {isEditing ? (
            <ScopeForm
              isNew={isNewScope}
              refreshData={async () => {
                try {
                  await read(id);
                } catch (error) {
                  console.error("Error al cargar los detalles del scope:", error);
                }
              }}
              setIsEditing={setIsEditing}
              initialScopeData={data}
            />
          ) : (
            <ScopeInfo scope={data} />
          )}
          <Box>
            {!isNewScope &&
              (isEditing ? (
                <Button variant="contained" color="primary" onClick={handleEditToggle}>
                  Cancelar
                </Button>
              ) : (
                <IconButton aria-label="edit" color="primary" onClick={handleEditToggle}>
                  <FiEdit2 />
                </IconButton>
              ))}
            {!isNewScope && (
              <IconButton aria-label="delete" color="secondary" onClick={handleOpenDeleteDialog}>
                <FiTrash2 />
              </IconButton>
            )}
          </Box>
        </Stack>
      )}
      <ConfirmDialog
        open={confirmOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        entityName="scope"
        entityLabel={itemName}
      />
    </Window>
  );
};

export default ScopeDetail;
